<div class="card card-redlaboral m-4">
    <div class="card-body">
        <div class="row">
            <div class="col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <h4 class="mt-0 mb-0 text-primary">
                    <i class="fa-solid fa-user-tie"></i>
                    Candidatos
                </h4>
            </div>
            <div class="col-xxl-6 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-xxl-2 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div class="form-group mb-3">
                    <label>Núm Identificación</label>
                    <div>
                        <input type="text" class="form-control" />
                    </div>
                </div>
            </div>
            <div class="col-xxl-2 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div class="form-group mb-3">
                    <label>Nombre</label>
                    <div>
                        <input type="text" class="form-control" />
                    </div>
                </div>
            </div>
            <div class="col-xxl-2 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div class="form-group mb-3">
                    <label>Apellido</label>
                    <div>
                        <input type="text" class="form-control" />
                    </div>
                </div>
            </div>
            <div class="col-xxl-2 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                <div class="mt-button">
                    <button type="button" class="btn btn-primary">
                        <i class="fa-solid fa-magnifying-glass"></i>
                        Buscar
                    </button>
                    <a href="javascript:void(0);" class="text-decoration-none mx-1" (click)="showFilter()">
                        <i class="fa-solid fa-filter"></i>
                        Más filtros
                    </a>
                </div>
            </div>
        </div>
        @if (showFilters)
        {
            <div class="card mb-2">
                <div class="card-body">
                    <div class="row">
                        <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12" hidden>
                            <div class="form-group mb-3">
                                <label>País</label>
                                <div>
                                    <select class="form-control">
                                        <option value=""></option>
                                        <option value="1">País A</option>
                                        <option value="2">País B</option>
                                        <option value="3">País C</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="form-group mb-3">
                                <label>Provincia</label>
                                <div>
                                    <select class="form-control">
                                        <option value=""></option>
                                        <option value="1">Provincia A</option>
                                        <option value="2">Provincia B</option>
                                        <option value="3">Provincia C</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12" hidden>
                            <div class="form-group mb-3">
                                <label>Municipio</label>
                                <div>
                                    <select class="form-control">
                                        <option value=""></option>
                                        <option value="1">Municipio A</option>
                                        <option value="2">Municipio B</option>
                                        <option value="3">Municipio C</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12" hidden>
                            <div class="form-group mb-3">
                                <label>Ciudad</label>
                                <div>
                                    <select class="form-control">
                                        <option value=""></option>
                                        <option value="1">Ciudad A</option>
                                        <option value="2">Ciudad B</option>
                                        <option value="3">Ciudad C</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12" hidden>
                            <div class="form-group mb-3">
                                <label>Tipo de contrato</label>
                                <div>
                                    <select class="form-control">
                                        <option value=""></option>
                                        <option value="1">Tiempo completo</option>
                                        <option value="2">Medio tiempo</option>
                                        <option value="3">Freelance</option>
                                        <option value="4">Temporal</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12" hidden>
                            <div class="form-group mb-3">
                                <label>Empresa</label>
                                <div>
                                    <select class="form-control">
                                        <option value=""></option>
                                        <option value="1">Empresa A</option>
                                        <option value="2">Empresa B</option>
                                        <option value="3">Empresa C</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="form-group mb-3">
                                <label>Profesión</label>
                                <div>
                                    <select class="form-control">
                                        <option value=""></option>
                                        <option value="1">Profesión A</option>
                                        <option value="2">Profesión B</option>
                                        <option value="3">Profesión C</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12" hidden>
                            <div class="form-group mb-3">
                                <label>Rango de edad</label>
                                <div class="input-group">
                                    <input type="number" min="0" step="1" class="form-control" placeholder="Min" />
                                    <input type="number" min="0" step="1" class="form-control" placeholder="Max" />
                                </div>
                            </div>
                        </div>
                        <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            <div class="mt-button">
                                <button type="button" class="btn btn-primary">
                                    <i class="fa-solid fa-magnifying-glass"></i>
                                    Buscar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        } -->
        <hr class="mt-3 mb-3" />
        <div class="table-responsive">
            <table class="table table-theme">
                <thead>
                    <tr>
                        <th class="text-start" width="105px"></th>
                        <th class="text-start">Candidato</th>
                        <th class="text-start">Identificación</th>
                        <th class="text-start">Provincia</th>
                        <th class="text-start">Profesión</th>
                        <th class="text-start">Curriculums</th>
                        <th class="text-start"></th>
                        <th class="text-center" width="110px">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    @for(item of candidatesListFiltered; track item)
                    {
                        <tr>
                            <td class="text-start p-0">
                                <img [src]="item.file" alt="foto" class="img-fluid rounded" style="max-width: 60px;" />
                            </td>
                            <td class="text-start">
                                <p class="mb-0">
                                    {{item.firstName}} {{item.lastName}}
                                </p>
                                <span class="badge rounded-pill text-bg-secondary mx-1">
                                    <i class="fa-regular fa-calendar"></i>
                                    {{item.birthDate | date:'dd/MM/yyyy'}}
                                </span>
                            </td>
                            <td class="text-start">
                                <span class="badge rounded-pill text-bg-primary">{{item.typeIdentification}}</span>
                                <p class="mb-0">
                                    {{item.identification}}
                                </p>
                            </td>
                            <td class="text-start">
                                {{item.nationality}}
                            </td>
                            <td class="text-start">
                                {{item.professionalProfile}}
                            </td>
                            <td class="text-start">
                                0
                            </td>
                            <td class="text-center">
                            </td>
                            <td class="text-center">
                                <button
                                    type="button"
                                    class="btn btn-info btn-sm me-2"
                                    title="Ver detalles"
                                    [routerLink]="['/admin/candidates', item.userId]">
                                    <i class="fa-solid fa-eye"></i>
                                </button>
                                <!-- <button
                                    type="button"
                                    class="btn btn-primary btn-sm me-2"
                                    title="Editar">
                                    <i class="fa-solid fa-pencil"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-outline-danger btn-sm me-2"
                                    title="Eliminar">
                                    <i class="fa-solid fa-trash-can"></i>
                                </button> -->
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>